import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const FileIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      aria-label="file icon"
      role="img"
      viewBox="0 0 25 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.948 6.1238L18.7052 0.881078C18.1429 0.318688 17.3805 0 16.5869 0H3.83315C2.17723 0.00624878 0.83374 1.34974 0.83374 3.00566V29.0006C0.83374 30.6565 2.17723 32 3.83315 32H21.8296C23.4856 32 24.8291 30.6565 24.8291 29.0006V8.24839C24.8291 7.45479 24.5104 6.68619 23.948 6.1238ZM21.5859 8.00469H16.8306V3.24937L21.5859 8.00469ZM3.83315 29.0006V3.00566H13.8312V9.50439C13.8312 10.3355 14.4998 11.0041 15.3309 11.0041H21.8296V29.0006H3.83315ZM17.0806 14.0035H15.2809C15.006 14.0035 14.756 14.1535 14.6248 14.3972C13.5 16.4655 13.2376 17.0467 12.8376 18.0027C11.9691 16.1843 12.4065 16.9217 11.0505 14.3972C10.9193 14.1535 10.6631 14.0035 10.3881 14.0035H8.58223C8.00109 14.0035 7.64491 14.6284 7.93235 15.1283L10.8255 20.0023L7.93235 24.8764C7.63866 25.3763 8.00109 26.0012 8.58223 26.0012H10.3881C10.6631 26.0012 10.913 25.8512 11.0442 25.6075C12.4002 23.108 12.4815 22.7955 12.8314 22.002C13.7625 23.8891 13.2001 22.9955 14.6185 25.6075C14.7498 25.8512 15.006 26.0012 15.2809 26.0012H17.0806C17.6617 26.0012 18.0179 25.3763 17.7304 24.8764L14.831 20.0023C14.8747 19.9336 16.7244 16.8467 17.7242 15.1283C18.0179 14.6284 17.6555 14.0035 17.0806 14.0035Z"
        fill="currentColor"
      />
    </Icon>
  );
};
